import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { alarmLogId: String }

  connect() {
    this.open()
  }

  // モーダルを開くときの処理
  open() {
    this.element.classList.remove('opacity-0', 'pointer-events-none')
    this.element.classList.add('opacity-100', 'pointer-events-auto')
    document.body.classList.add('overflow-hidden') // モーダルの外側のスクロールを無効化
  }

  // モーダルを閉じるときの処理
  close() {
    this.element.classList.remove('opacity-100', 'pointer-events-auto')
    this.element.classList.add('opacity-0', 'pointer-events-none')
    document.body.classList.remove('overflow-hidden')
  }

  beforeCache() {
    this.element.remove() // 「Turbo Drive」のキャッシュにモーダルが含まれないように削除
  }

  disconnect() {
    document.body.classList.remove('overflow-hidden') // モーダルの外側のスクロールを無効化
  }
}